import { Close } from "@mui/icons-material";
import styled from "@mui/material/styles/styled";

import IconButton, { IconButtonProps } from "@rui/IconButton";

export const ModalCloseIconButton = styled((props: IconButtonProps) => (
  <IconButton variant="outlined" {...props}>
    <Close />
  </IconButton>
))({
  width: "34px",
  height: "34px",
  borderRadius: "8px",
});
export default ModalCloseIconButton;
